const services = [
  {
    id: 1,
    title: 'Air Freight',
    description:
      'Fast, reliable air cargo services for time-sensitive shipments. Priority handling and express delivery options available worldwide.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
      </svg>
    ),
    features: ['Express and standard air cargo', 'Door-to-door delivery', 'Temperature-controlled transport', 'Dangerous goods handling'],
  },
  {
    id: 2,
    title: 'Ocean Freight',
    description:
      'Cost-effective sea freight solutions for large volume shipments. Full container load (FCL) and less than container load (LCL) options.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
      </svg>
    ),
    features: ['FCL and LCL services', 'Project cargo handling', 'Port-to-port and door-to-door', 'Container tracking'],
  },
  {
    id: 3,
    title: 'Customs Brokerage',
    description:
      'Expert customs clearance services ensuring compliance with international trade regulations and minimizing delays.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    features: ['Import/export documentation', 'Duty optimization', 'Trade compliance consulting', 'Regulatory updates'],
  },
  {
    id: 4,
    title: 'Warehousing',
    description:
      'Secure storage and distribution facilities with advanced inventory management systems and flexible storage solutions.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    features: ['Climate-controlled storage', 'Inventory management', 'Pick and pack services', 'Cross-docking'],
  },
  {
    id: 5,
    title: 'Ground Transportation',
    description:
      'Comprehensive land transport solutions including trucking, rail, and intermodal services for domestic and cross-border shipments.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
      </svg>
    ),
    features: ['Full truckload (FTL)', 'Less than truckload (LTL)', 'Intermodal transport', 'Last-mile delivery'],
  },
  {
    id: 6,
    title: 'Supply Chain Management',
    description:
      'End-to-end supply chain optimization services including sourcing, procurement, and vendor management solutions.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    features: ['Supply chain consulting', 'Vendor management', 'Risk assessment', 'Performance analytics'],
  },
]

export default function Services() {
  return (
    <section className="py-16 bg-neutral">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="section-title">Comprehensive Logistics Services</h2>
          <p className="section-subtitle mx-auto">
            End-to-end supply chain solutions tailored to your business needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="card group hover:shadow-card-hover transition-all duration-300"
            >
              <div className="flex items-center mb-4">
                <div className="p-3 bg-primary/10 text-primary rounded-lg group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  {service.icon}
                </div>
              </div>
              
              <h3 className="font-display font-bold text-xl text-primary mb-3">
                {service.title}
              </h3>
              
              <p className="text-neutral-600 mb-4">
                {service.description}
              </p>

              <ul className="space-y-2 mb-6">
                {service.features.map((feature, index) => (
                  <li
                    key={index}
                    className="flex items-center text-sm text-neutral-600"
                  >
                    <svg
                      className="w-4 h-4 mr-2 text-profit flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

